import classes from './style';
import CloseIcon from '@mui/icons-material/Close';
import { RotateLeft, RotateRight, ZoomIn, ZoomOut, Crop } from '@mui/icons-material';
import { Grid, Typography, Tooltip, IconButton, DialogTitle as MuiDialogTitle, useMediaQuery, useTheme } from '@mui/material';

function DialogTitle(props) {
  const { onClose, title, rotate, setRotate, scale, setScale, cropImage, setCropImage, imgArray } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <MuiDialogTitle className={classes.root}>
      <Grid container spacing={1}>
        <Grid item md={8} sm={12} xs={12} style={{ margin: "auto" }}>
          <Typography variant="h5" style={matches ? {} : { marginLeft: '36px' }}>{title}
            {
              matches &&
              <IconButton aria-label="close" className={classes.closeButtonResp} style={{ float: "right" }} onClick={onClose} size="large">
                <CloseIcon />
              </IconButton>
            }
          </Typography>
        </Grid>
        <Grid item md={4} sm={12} xs={12} className={classes.center}>
          <Tooltip title="Crop" aria-label="crop">
            <IconButton disabled={imgArray?.length === 0} aria-label="zoom" onClick={() => setCropImage(!cropImage)} className={classes.button} size="large">
              <Crop />
            </IconButton>
          </Tooltip>
          <Tooltip title="Zoom In" aria-label="zoom-right">
            <IconButton disabled={imgArray?.length === 0 || !cropImage} aria-label="zoom" onClick={() => setScale(scale < 0 ? 0.1 : scale + 0.1)} className={classes.button} size="large">
              <ZoomIn />
            </IconButton>
          </Tooltip>
          <Tooltip title="Zoom Out" aria-label="zoom-left">
            <IconButton disabled={imgArray?.length === 0 || !cropImage} aria-label="zoom" onClick={() => setScale(scale > 0 ? -0.1 : scale - 0.1)} className={classes.button} size="large">
              <ZoomOut />
            </IconButton>
          </Tooltip>
          <Tooltip title="Rotate Right" aria-label="rotate-right">
            <IconButton disabled={imgArray?.length === 0 || !cropImage} aria-label="rotate" onClick={() => setRotate(rotate + 90)} className={classes.button} size="large">
              <RotateRight />
            </IconButton>
          </Tooltip>
          <Tooltip title="Rotate Left" aria-label="rotate-left">
            <IconButton disabled={imgArray?.length === 0 || !cropImage} aria-label="done" onClick={() => setRotate(rotate - 90)} className={classes.button} size="large">
              <RotateLeft />
            </IconButton>
          </Tooltip>
          {!matches && <Tooltip title="Close" aria-label="close">
            <IconButton aria-label="close" className={classes.closeButton} style={{ position: "absolute",right:"20px" }} onClick={onClose} size="large">
              <CloseIcon />
            </IconButton>
          </Tooltip>}
        </Grid>
      </Grid>
    </MuiDialogTitle>
  );
}

export default DialogTitle;